module.exports = __webpack_public_path__ + "static/img/news10.3c94d80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news10.jpg
// module id = AAUl
// module chunks = 1